import { render } from "./PoweredBy.vue?vue&type=template&id=ddedc5d6&scoped=true"
import script from "./PoweredBy.vue?vue&type=script&lang=js"
export * from "./PoweredBy.vue?vue&type=script&lang=js"

import "./PoweredBy.vue?vue&type=style&index=0&id=ddedc5d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Zayd\\Documents\\Web Development\\Clients Projects\\RHDesigns\\rhdesigns-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddedc5d6"]])

export default __exports__